<template>
  <v-sheet class="fill-height" tile color="#ffffff">
    <v-container fluid align="center">
      <template v-if="active_reservations.length >= 5">
        <v-row justify="center">
          <v-col cols="12" lg="4" align="center">
            You are only allowed to have 5 future spots reserved at one time.
            Please cancel one of your future spots before booking this spot<br /><br />
            <template v-for="record in active_reservations">
              <StoreTile
                mode="reservation"
                :reservation="record.reservation"
                :store="record.store"
                :key="record.reservation.id"
              ></StoreTile>
              <br />
            </template>
          </v-col>
        </v-row>
      </template>
      <template v-else-if="current_store_reservation">
        <v-row justify="center">
          <v-col cols="12" lg="4" align="center">
            You already have an active spot in line at this store. Please cancel
            your active spot in line before saving a new spot in line.<br /><br />
            <StoreTile
              mode="reservation"
              :reservation="current_store_reservation"
              :store="store"
              :key="current_store_reservation.id"
            ></StoreTile>
            <br />
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-list-item>
          <v-list-item-avatar class="avatar small">
            <SpotS3Image :image-path="brand.image"></SpotS3Image>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="brand-title">{{
              brand.name
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-row class="map-container-dense">
          <GmapMap
            :options="{
              streetViewControl: false,
              mapTypeControl: false,
              zoomControl: false,
              fullscreenControl: false,
              gestureHandling: 'none'
            }"
            :center="{ lat: store.lat, lng: store.lng }"
            :zoom="16"
            map-type-id="terrain"
          >
            <GmapMarker
              :clickable="false"
              :draggable="false"
              :position="{ lat: store.lat, lng: store.lng }"
            />
          </GmapMap>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" lg="4" align="center">
            <div class="closest-time title" v-html="closest_time_string"></div>
            <br />
            <v-btn
              :loading="loadingState"
              class="reserve-btn"
              color="primary"
              @click="reserveNow"
              :disabled="closest_time == -1 || closest_time == null"
            >
              <img src="/static/logo_small.png" alt="logo" />
              Save Spot&nbsp;&nbsp;
            </v-btn>
            <br />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" lg="4" align="center">
            <span class="title" style="opacity:.4">Or</span>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" lg="4" align="center">
            <div class="title">
              Reserve a future spot!
            </div>
            <br />
            <v-form class="pickers">
              <v-slide-x-transition mode="out-in">
                <v-date-picker
                  key="date"
                  v-if="step === 'date'"
                  first-day-of-week="1"
                  @click:date="step = 'time'"
                  prev-icon="arrow_back_ios"
                  next-icon="arrow_forward_ios"
                  color="primary"
                  v-model="date"
                  :allowed-dates="allowedDates"
                ></v-date-picker>

                <div key="time" v-if="step === 'time'">
                  <div class="v-picker__title primary">
                    <div class="v-time-picker-title">
                      <v-btn
                        color="white"
                        @click="step = 'date'"
                        small
                        icon
                        class="mr-auto"
                      >
                        <v-icon>arrow_back</v-icon>
                      </v-btn>
                      <div class="v-time-picker-title__time">
                        <div
                          class="v-picker__title__btn v-picker__title__btn--active"
                        >
                          {{ display_hour }}
                        </div>
                        <span>:</span>
                        <div class="v-picker__title__btn">
                          {{ displayMinutes }}
                        </div>
                      </div>
                      <div class="v-time-picker-title__ampm">
                        <div class="v-picker__title__btn">{{ mode }}</div>
                      </div>
                    </div>
                  </div>
                  <v-card
                    flat
                    color="primary"
                    style="background-color: white!important;"
                    class="v-picker__title primary--text time-picker"
                  >
                    <div
                      v-if="available_minutes_map"
                      class="v-time-picker-title"
                    >
                      <v-row>
                        <v-col>
                          <Scroller
                            @selected="updateHours"
                            :items="valid_hours"
                          ></Scroller>
                        </v-col>
                        <v-col>
                          <Scroller
                            @selected="updateMinutes"
                            :items="valid_minutes"
                          ></Scroller>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </div>
              </v-slide-x-transition>
            </v-form>
            <br />
            <v-btn
              :loading="loadingState || (date && !available_minutes_map)"
              color="primary"
              :disabled="!datetime_valid"
              large
              @click="reserve"
            >
              <span style="white-space: normal;" v-html="date_formatted">
              </span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-list style="width: 100%;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">location_on</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ store.address }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">phone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ store.phone }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset></v-divider>
          </v-list>
        </v-row>
        <v-row style="padding: 20px">
          <StoreOpenTable :store="store" />
        </v-row>
      </template>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import {
  doCreateReservationForTime,
  doCreateReservationNextAvailable,
  doGetMinuteMap
} from "../graphql/mutations";
import { process_api_error, getPrefixFromMoment } from "@/utils/utils";
import {
  PAGE_IDS,
  RESERVATION_STATUS,
  determineStatusValue
} from "../utils/constants";
import Vue from "vue";
import StoreTile from "../Stores/StoreTile";
import StoreOpenTable from "../Elements/StoreOpenTable";
import FullScreenMap from "../Elements/FullScreenMap";
import SpotS3Image from "../Pages/SpotS3Image";
import Scroller from "../Elements/Scroller";
// import luxon from "luxon";
import { DateTime } from "luxon";

const moment = require("moment-timezone");

export default {
  name: "ReservationAdd",
  components: {
    Scroller,
    SpotS3Image,
    FullScreenMap,
    StoreOpenTable,
    StoreTile
  },
  computed: {
    ...mapGetters([
      "loadingState",
      "getStoreById",
      "getBrandById",
      "allReservationsByThisUser",
      "currentUser"
    ]),

    displayMinutes() {
      if (this.minute || this.minute == 0) {
        return this.minute;
      } else {
        return "--";
      }
    },
    active_reservations() {
      var result = this.allReservationsByThisUser.filter(item => {
        if (item.owner == this.currentUser.username) {
          var status = determineStatusValue(item, this.store);
          if (
            status == RESERVATION_STATUS.ACTIVE ||
            status == RESERVATION_STATUS.IN_STORE
          ) {
            return true;
          }
        }
        return false;
      });
      var res = [];
      for (var item of result) {
        var store = this.getStoreById(item.store_id);
        if (store) {
          res.push({ reservation: item, store: store });
        }
      }
      return res;
    },
    firstReservation() {
      for (var res of this.allReservationsByThisUser) {
        if (
          res.owner == this.currentUser.username &&
          res.iscancelled == false
        ) {
          return false;
        }
      }
      return true;
    },
    current_store_reservation() {
      var store_id = this.store.id;
      var result = this.active_reservations.find(item => {
        if (item.store.id == store_id) {
          return true;
        }
        return false;
      });
      if (result) return result.reservation;
      else return undefined;
    },
    datetime_valid() {
      //  console.log("this.date : ",this.date);
      //  console.log("this.hour : ",this.hour);
      //  console.log("this.minute : ",this.minute);
      return this.date && this.hour && this.minute;
    },
    date_formatted() {


      if (this.datetime_valid) {
        return (
          "Reserve at <br/>" +
          moment(this.date + " " + this.hour + ":" + this.minute).format(
            "ddd, MMM D, YYYY, h:mma"
          )
        );
      }
      if (this.valid_hours.length === 0 && this.date) {
        return "No spots available on this date";
      }
      return "Select valid date and time";
    },

    store() {
      // console.log("get store by id : ",this.getStoreById(this.$route.params.store_id))

      return this.getStoreById(this.$route.params.store_id);
    },
    brand() {
      // console.log("Timezon : ",);
      return this.getBrandById(this.store.brand_id);
    },
    current_date() {
      if (this.current_time) {
        return moment(this.current_time).startOf("day");
      } else {
        return moment.tz(this.store.timezone).startOf("day");
      }
    },
    closest_time() {
      if (this.todayMinutesMap) {
        var now = moment.tz(this.store.timezone);
        var start_index = 24 * 60 + now.hour() * 60 + now.minute() + 1;
        var found_slots = 0;
        for (var i = start_index; i < 72 * 60; i++) {
          if (this.todayMinutesMap[i] > 0) {
            found_slots += 1;
          } else {
            found_slots = 0;
          }
          if (found_slots >= this.store.duration) {
            return now
              .startOf("day")
              .add(i + 1 - found_slots - 24 * 60, "minute");
          }
        }
        return null;
      }
      return -1;
    },
    closest_time_string() {
      var ct = this.closest_time;
      if (ct) {
        if (ct == -1) {
          return "Calculating...<br/><br/>";
        }
        if (moment(ct).isSame(moment().tz(this.store.timezone), "day")) {
          return (
            "To enter by " +
            ct.format("h:mma") +
            ", <br/>save your spot in line now!"
          );
        } else if (
          moment(ct).isSame(
            moment()
              .tz(this.store.timezone)
              .add(1, "day"),
            "day"
          )
        ) {
          return (
            "To enter by " +
            ct.format("h:mma") +
            " tomorrow,<br/>save your spot in line now!"
          );
        } else {
          return "To enter by " + ct.format("ddd, MMM Do, YYYY, h:mma");
        }
      }
      return "No slots available today and tomorrow";
    },
    todayMinutesMap() {
      if (this.today_minutes_map == undefined) {
        var cdutc = moment.utc(
          this.current_date.format("YYYY-MM-DDT") + "00:00"
        );
        this.getMinutesMap(cdutc, cdutc.isoWeekday(), "today_minutes_map");
        return this.today_minutes_map;
      } else {
        var results = new Array(72 * 60).fill(0);
        var time = this.current_time
          ? this.current_time
          : moment().tz(this.store.timezone);
        //TODO This is potentially wrong as this put 0s for yesterday, not for today. But not a problem as all lookups
        //start from today anyway
        var determined_time = Math.ceil(
          (time.unix() - this.current_date.unix()) / 60
        );
        if (determined_time < 0) {
          determined_time = 0;
        }
        for (var i = determined_time; i < 72 * 60; i++) {
          results[i] = this.today_minutes_map[i];
        }
        return results;
      }
    },
    availableMinutesMap() {
      if (this.date) {

        if (this.available_minutes_map == undefined) {
          var dt = moment.utc(this.date).startOf("day");

          this.getMinutesMap(dt, dt.isoWeekday(), "available_minutes_map");

          return new Array(72 * 60).fill(0);
        } else {
          var results = new Array(72 * 60).fill(0);
          var time = this.current_time
            ? this.current_time
            : moment().tz(this.store.timezone);
          var determined_time = Math.ceil(
            (time.unix() -
              moment
                .tz(this.date, this.store.timezone)
                .startOf("day")
                .unix()) /
              60
          );
          if (determined_time < 0) {

            determined_time = 0;
          }

          for (var i = determined_time + 24 * 60; i < 72 * 60; i++) {
            results[i] = this.available_minutes_map[i];
          }
          // console.log("result s : ", results);
          return results;
        }
      } else {
        return new Array(72 * 60).fill(0);
      }
    },
    valid_hours() {
      var valid_am = [];
      var valid_pm = [];
      for (var i = 0; i < 24; i++) {
        if (this.allowedHours(i)) {
          if (i >= 12) {
            if (i === 12) {
              valid_am.push({
                name: 12,
                value: 0,
                selected: false
              });
            } else {
              valid_pm.push({
                name: i % 12,
                value: i,
                selected: false
              });
            }
          } else {
            if (i === 0) {
              valid_pm.push({ name: 12, value: 12, selected: false });
            } else {
              valid_am.push({ name: i, value: i, selected: false });
            }
          }
        }
      }
      for (let time of valid_am) {
        if (time.value < 10) {
          time.value = time.value.toString();
          time.value = "0" + time.value;
        }
      }
      return [...valid_am, ...valid_pm];
    },
    valid_minutes() {
      var result = [];
      for (var i = 0; i < 60; i++) {

        if(i % 5 === 0){
        if (this.allowedMinutes(i)) {
          if (i < 10) {
            i = "0" + i;
          }
          result.push({
            name: i,
            value: i,
            selected: false
          });
        }
        }

      }
      return result;
    }
  },
  data: function() {
    return {
      step: "date",
      mode: "AM",
      display_hour: "--",
      pm: 0,
      date: undefined,
      hour: undefined,
      minute: undefined,
      current_time: undefined,
      timer: undefined,
      today_minutes_map: undefined,
      available_minutes_map: undefined
    };
  },
  mounted() {
    this.$store.dispatch("reloadReservations");
    this.timer = setInterval(this.updateTime, 30000);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  watch: {
    date(new_value, old_value) {
      if (new_value != old_value) {
        this.hour = undefined;
        this.minute = undefined;
        this.available_minutes_map = undefined;
      }
    },
    current_date(new_value, old_value) {
      if (new_value != old_value) {
        this.today_minutes_map = undefined;
      }
    }
  },
  methods: {
    updateHours(val) {
      this.hour = val;
      if (this.hour) {
        if (this.hour >= 12) {
          this.display_hour = val % 12;
          this.mode = "PM";
        } else {
          this.mode = "AM";
          if (val === "00") {
            this.hour = 12;
            this.display_hour = "12";
          } else {
            this.display_hour = val;
          }
        }
      } else {
        this.display_hour = "--";
      }
    },
    updateMinutes(val) {
      this.minute = val;
    },
    clearTime() {
      this.hour = undefined;
      this.minute = undefined;
    },
    async updateTime() {
      this.current_time = moment.tz(this.store.timezone);
    },
    allowedDates(val) {
      // var date = moment()
      //   .tz(this.store.timezone)
      //   .startOf("day");
      // console.log("day : ", date);

    var date = moment().subtract(3, 'years').tz(this.store.timezone);

      var analyzed_date = moment.tz(val, this.store.timezone).startOf("day");
      if (date <= analyzed_date) {
        var suffix = getPrefixFromMoment(analyzed_date);
        var prev_suffix = getPrefixFromMoment(
          moment(analyzed_date).add(-1, "day")
        );
        if (
          this.store["open_time_" + suffix] !=
          this.store["close_time_" + suffix]
        ) {
          return true;
        } else {
          if (
            this.store["close_time_" + prev_suffix] <
            this.store["open_time_" + prev_suffix]
          ) {
            return true;
          }
        }
      }
      return false;
    },
    allowedHours(val) {
      var slots_count = 0;
      for (var i = 0; i < 60; i++) {
        if (this.availableMinutesMap[24 * 60 + val * 60 + i] > 0) {
          slots_count++;
        } else {
          slots_count = 0;
        }
        if (slots_count >= this.store.duration) {
          return true;
        }
        // console.log("slot count : ",slots_count);
        if (i == 59 && slots_count != 0) {
          var length_to_check = this.store.duration - slots_count;
          for (var j = 0; j < length_to_check; j++) {
            if (this.availableMinutesMap[24 * 60 + val * 60 + 60 + j] > 0) {
              slots_count++;
            } else {
              slots_count = 0;
            }
            if (slots_count >= this.store.duration) {
              return true;
            }
          }
        }
      }

      if (this.hour == val) {
        this.hour = undefined;
      }
      return false;
    },
    allowedMinutes(val) {


      if (this.hour) {
        for (var i = 0; i < this.store.duration; i++) {
          if (
            this.availableMinutesMap[24 * 60 + this.hour * 60 + val + i] <= 0
          ) {
            if (this.minute == val) {
              this.minute = undefined;
            }
            return false;
          }
        }
      }
      return true;
    },

    async getMinutesMap(date, day_index, where_to_set) {
      var result = await this.$Amplify.API.graphql(
        this.$Amplify.graphqlOperation(doGetMinuteMap, {
          store_id: this.$route.params.store_id,
          dt: date.unix(),
          day_index: day_index
        })
      );
      var res = Object.freeze(result.data.doGetMinuteMap);
      Vue.set(this, where_to_set, res);
    },
    async reserveNow() {
      this.$store.dispatch("startLoading");
      var ct = moment(this.closest_time);

      var selectedDateString = ct.format("YYYY-MM-DDTHH:mm")+":00";

      var storeSecond = this.calculateReserveDateTime(selectedDateString);

      var start_shop_time = ct.format("YYYY-MM-DDT") + "00:00";

      this.$Amplify.API.graphql(
        this.$Amplify.graphqlOperation(doCreateReservationNextAvailable, {
          store_id: this.$route.params.store_id,
          // dt: moment.utc(ct.format("YYYY-MM-DDTHH:mm")).unix(),
          dt:storeSecond,
          owner: this.currentUser.username,
          day_start_dt: moment.utc(start_shop_time).unix(),
          day_index: moment.utc(start_shop_time).isoWeekday(),
          first: this.firstReservation ? 1 : 0
        })
      )
        .then(res => {
          this.$store.dispatch("stopLoading");
          this.$store.dispatch(
            "addReservation",
            res.data.doCreateReservationNextAvailable
          );
          this.$router.push({
            name: PAGE_IDS.RESERVATION_DETAIL,
            params: {
              reservation_id: res.data.doCreateReservationNextAvailable.id
            }
          });
        })
        .catch(e => {
          this.$store.dispatch("stopLoading");
          process_api_error(`Error Creating Reservation`, e);
        });
    },
    async reserve() {
      if (
        this.allowedDates(this.date) &&
        this.allowedHours(this.hour) &&
        this.allowedMinutes(this.minute)
      )
        this.$store.dispatch("startLoading");


      /** Original code */
      var reservationUserTimeUTCUnix = Math.round(
        new Date(
          new Date(
            this.date + " " + this.hour + ":" + this.minute
          ).toUTCString()
        ).getTime() / 1000
      );

      var selectedDateString = this.date + "T" + this.hour + ":" + this.minute+":00";
      // var storeTime = new DateTime.fromISO(selectedDateString, {
      //   zone: this.store.timezone
      // });
      // var storeUTC = storeTime.toUTC();
      // var storemillisecond = (storeUTC).toMillis()/ 1000;
      var storemillisecond =this.calculateReserveDateTime(selectedDateString);

      this.$Amplify.API.graphql(
        this.$Amplify.graphqlOperation(doCreateReservationForTime, {
          store_id: this.$route.params.store_id,
          // dt: moment.utc(this.date + " " + this.hour + ":" + this.minute).startOf('minute').unix(),
          dt: reservationUserTimeUTCUnix,
          // dt:storemillisecond, /** AKG develop code*/
          owner: this.currentUser.username,
          day_start_dt: moment
            .utc(this.date + " 00:00")
            .startOf("minute")
            .unix(),
          day_index: moment
            .utc(this.date + " 00:00")
            .startOf("minute")
            .isoWeekday(),
          first: this.firstReservation ? 1 : 0
        })
      )
        .then(res => {
          this.$store.dispatch("stopLoading");
          this.$store.dispatch(
            "addReservation",
            res.data.doCreateReservationForTime
          );
          this.$router.push({
            name: PAGE_IDS.RESERVATION_DETAIL,
            params: { reservation_id: res.data.doCreateReservationForTime.id }
          });
        })
        .catch(e => {
          this.$store.dispatch("stopLoading");
          process_api_error(`Error Creating Reservation`, e);
        });
    },
    calculateReserveDateTime(dateTimeString){
    var storeTime = new DateTime.fromISO(dateTimeString, {
        zone: this.store.timezone
      });
      var storeUTC = storeTime.toUTC();
      var storemillisecond = (storeUTC).toMillis()/ 1000;

      return storemillisecond;

    }

  }
};
</script>
<style lang="scss">
.time-picker {
  min-height: 270px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  border-top-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
  margin-top: -16px;
}

.closest-time {
  color: #1565c0;
  text-align: center;
  font-weight: bold;
}

.brand-title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.12px;
}

.pickers {
  width: 86%;
  display: grid;
  grid-row-gap: 1rem;

  .hour-minute {
    place-self: center;
    display: grid;
    grid-template-columns: 100px 4px 100px auto;
    grid-column-gap: 0.5rem;

    .dots {
      justify-self: center;

      .material-icons:nth-child(1) {
        padding-top: 18px;
      }

      .material-icons {
        font-size: 14px;
      }
    }

    .v-input__slot {
      height: 72px;
    }

    .v-btn-toggle {
      flex-direction: column;

      .v-btn {
        padding: 0 !important;
        min-width: 56px !important;
        background-color: white !important;
        border: 1px solid rgba(0, 0, 0, 0.12);
      }

      .v-btn:nth-child(1) {
        border-radius: 4px 4px 0 0;
      }

      .v-btn:nth-child(2) {
        border-radius: 0 0 4px 4px;
      }
    }
  }
}

.reserve-btn {
  img {
    width: 24px;
    height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/Reservations/ReservationAdd.vue